import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center">
      {/* Enhanced Logo with Modern Design */}
      <div className="flex items-center justify-center mb-10">
        <div className="relative group">
          {/* Main logo container */}
          <div className="w-20 h-20 bg-gradient-to-br from-white/25 to-white/10 backdrop-blur-md rounded-3xl flex items-center justify-center shadow-2xl border border-white/30 group-hover:from-white/30 group-hover:to-white/15 transition-all duration-300">
            <Icon name="Clock" size={36} className="text-white drop-shadow-xl" />
          </div>
          {/* Animated glow effect */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-3xl animate-pulse opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>
          {/* Subtle outer ring */}
          <div className="absolute -inset-1 bg-gradient-to-br from-white/20 to-white/5 rounded-3xl blur-sm group-hover:blur-md transition-all duration-300"></div>
        </div>
        <div className="ml-6 text-left">
          <h1 className="text-5xl font-bold text-white mb-2 tracking-tight">
            Intime
          </h1>
          <p className="text-xl text-white/90 font-semibold tracking-wide">
            Applicant Tracking System
          </p>
          <div className="flex items-center mt-2 space-x-2">
            <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
            <span className="text-sm text-white/70 font-medium">Enterprise Ready</span>
          </div>
        </div>
      </div>
      
      {/* Enhanced Welcome Message with Better Typography */}
      <div className="space-y-6 max-w-2xl mx-auto">
        <h2 className="text-4xl font-bold text-white mb-4 leading-tight">
          Welcome to the Future of
          <span className="block bg-gradient-to-r from-white to-white/80 bg-clip-text text-transparent">
            Intelligent Hiring
          </span>
        </h2>
        <p className="text-white/90 text-xl leading-relaxed font-medium">
          Access your AI-powered recruitment workspace and transform your talent acquisition process with 
          cutting-edge automation, analytics, and candidate management tools.
        </p>
        
        {/* Key Benefits */}
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <div className="px-4 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20">
            <span className="text-white/90 text-sm font-medium">✨ AI-Powered Matching</span>
          </div>
          <div className="px-4 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20">
            <span className="text-white/90 text-sm font-medium">📊 Advanced Analytics</span>
          </div>
          <div className="px-4 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20">
            <span className="text-white/90 text-sm font-medium">🔒 Enterprise Security</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginHeader;